import React from "react";
import { Sheet, SheetClose, SheetContent, SheetTrigger } from "./sheet";

interface Props {
  children: React.ReactNode;
}

export const ChatbotSheet = ({ children }: Props) => {
  return (
    <Sheet>
      <SheetTrigger>{children}</SheetTrigger>
      <SheetContent className="z-[999999] p-0 w-[100dvw] xl:w-auto !max-w-[500px] select-none">
        <header className="bg-[#0c131f] h-[4.5rem] p-4 flex items-center">
          <div className="flex items-center w-full justify-between">
            <h1 className="text-xl text-white font-bold">Besoin d’aide ?</h1>
            <SheetClose>
              <h3 className="text-[#8de8fe] padding-[calc(0.9375rem)] flex items-center justify-center text-sm cursor-pointer">
                Fermer
              </h3>
            </SheetClose>
          </div>
        </header>
        <section className="p-5 xl:p-10 flex flex-col justify-between h-[90dvh] xl:h-[94dvh]">
          <div>
            <div
              style={{
                boxSizing: "border-box",
                padding: "0px 16px 24px 0px",
                margin: "0px",
                listStyle: "outside none none",
                textDecoration: "none solid rgb(0, 0, 0)",
                fontFamily: "Avenir",
                transition: "all 0.3s ease-in-out 0s",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "18px",
                  boxSizing: "border-box",
                  margin: "0px",
                  fontFamily: "Avenir",
                  fontWeight: 500,
                  padding: "0px",
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(0, 0, 0)",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              >
                Nous traitons vos données conformément à notre charte de
                confidentialité.{" "}
              </p>
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "18px",
                  boxSizing: "border-box",
                  margin: "0px",
                  fontFamily: "Avenir",
                  fontWeight: 500,
                  padding: "0px",
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(0, 0, 0)",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              >
                <a
                  href="/informations-legales/confidentialite"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "13px",
                    lineHeight: "18px",
                    boxSizing: "border-box",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontWeight: 500,
                    color: "rgb(20, 112, 138)",
                    textDecoration: "underline solid rgba(20, 112, 138, 0.4)",
                    cursor: "pointer",
                    position: "relative",
                    display: "inline",
                    padding: "0px",
                    listStyle: "outside none none",
                    transition: "all 0.3s ease-in-out 0s",
                  }}
                >
                  En savoir plus sur la charte de confidentialité
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "16px",
                      width: "1rem",
                      alignSelf: "normal",
                      fill: "rgb(20, 112, 138)",
                      flexShrink: 0,
                      marginLeft: "6px",
                      position: "relative",
                      top: "3px",
                      margin: "0px 0px 0px 6px",
                      padding: "0px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      fontFamily: "Avenir",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                    className="inline-block"
                  >
                    <path
                      d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                      style={{
                        boxSizing: "border-box",
                        margin: "0px",
                        padding: "0px",
                        listStyle: "outside none none",
                        textDecoration: "none solid rgb(20, 112, 138)",
                        fontFamily: "Avenir",
                        transition: "all 0.3s ease-in-out 0s",
                      }}
                    ></path>
                  </svg>
                </a>
              </p>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                margin: "0px",
                padding: "0px",
                listStyle: "outside none none",
                textDecoration: "none solid rgb(0, 0, 0)",
                fontFamily: "Avenir",
                transition: "all 0.3s ease-in-out 0s",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  margin: "0px",
                  padding: "0px",
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(0, 0, 0)",
                  fontFamily: "Avenir",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              >
                <div
                  role="log"
                  aria-live="polite"
                  style={{
                    boxSizing: "border-box",
                    margin: "0px",
                    padding: "0px",
                    listStyle: "outside none none",
                    textDecoration: "none solid rgb(0, 0, 0)",
                    fontFamily: "Avenir",
                    transition: "all 0.3s ease-in-out 0s",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(0, 0, 0)",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  >
                    SNCF Connect a écrit :{" "}
                  </span>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "16px",
                      whiteSpace: "pre-line",
                      width: "fit-content",
                      margin: "0px 0px 16px",
                      padding: "0px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(0, 0, 0)",
                      fontFamily: "Avenir",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  >
                    <div
                      tabIndex={-1}
                      data-test="bubble-message-bot"
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        padding: "16px",
                        background:
                          "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                        borderRadius: "32px 32px 32px 0px",
                        margin: "0px",
                        listStyle: "outside none none",
                        textDecoration: "none solid rgb(0, 0, 0)",
                        fontFamily: "Avenir",
                        transition: "all 0.3s ease-in-out 0s",
                      }}
                    >
                      <p
                        aria-label="Bonjour, je suis le bot SNCF Connect ! Posez-moi votre question, je ferai tout pour y répondre."
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily: "Avenir",
                          fontWeight: 500,
                          padding: "0px",
                          listStyle: "outside none none",
                          textDecoration: "none solid rgb(0, 0, 0)",
                          transition: "all 0.3s ease-in-out 0s",
                        }}
                      >
                        Bonjour, je suis le bot SNCF Connect ! Je suis
                        indisponible pour le moment, veuillez réessayer
                        ultérieurement.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  margin: "0px",
                  padding: "0px",
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(0, 0, 0)",
                  fontFamily: "Avenir",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              >
                <div
                  role="log"
                  aria-live="polite"
                  style={{
                    boxSizing: "border-box",
                    margin: "0px",
                    padding: "0px",
                    listStyle: "outside none none",
                    textDecoration: "none solid rgb(0, 0, 0)",
                    fontFamily: "Avenir",
                    transition: "all 0.3s ease-in-out 0s",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(0, 0, 0)",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  >
                    SNCF Connect a écrit :{" "}
                  </span>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "16px",
                      whiteSpace: "pre-line",
                      width: "fit-content",
                      margin: "0px 0px 16px",
                      padding: "0px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(0, 0, 0)",
                      fontFamily: "Avenir",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  ></div>
                  <span
                    aria-live="polite"
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(0, 0, 0)",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  >
                    Veuillez sélectionner une réponse ou écrire votre message
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              style={{
                boxSizing: "border-box",
                fontFamily: "Avenir",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "23px",
                color: "rgb(12, 19, 31)",
                cursor: "text",
                display: "flex",
                WebkitBoxAlign: "center",
                alignItems: "center",
                position: "relative",
                borderRadius: "8px",
                padding: "18.5px 14px 18.5px 16px",
                paddingLeft: "16px",
                margin: "0px",
                listStyle: "outside none none",
                textDecoration: "none solid rgb(12, 19, 31)",
                transition: "all 0.3s ease-in-out 0s",
              }}
            >
              <textarea
                aria-invalid="false"
                disabled
                name="inputBot"
                placeholder="Indisponible pour le moment, veuillez réessayer ultérieurement."
                aria-required="false"
                style={{
                  backgroundColor: "inherit",
                  height: "22px",
                  overflow: "hidden",
                  fontSize: "16px",
                  lineHeight: "22px",
                  boxSizing: "content-box",
                  fontFamily: "Avenir",
                  margin: "0px",
                  fontStyle: "normal",
                  fontVariant: "normal",
                  fontStretch: "100%",
                  fontOpticalSizing: "auto",
                  fontKerning: "auto",
                  fontFeatureSettings: "normal",
                  fontVariationSettings: "normal",
                  letterSpacing: "normal",
                  color: "rgb(12, 19, 31)",
                  border: "0px none rgb(12, 19, 31)",
                  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                  display: "block",
                  minWidth: "0px",
                  width: "100%",
                  animationName: "mui-auto-fill-cancel",
                  animationDuration: "0.01s",
                  resize: "none",
                  padding: "0px",
                  fontWeight: 500,
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(12, 19, 31)",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              ></textarea>
              <textarea
                aria-hidden="true"
                readOnly
                tabIndex={-1}
                style={{
                  visibility: "hidden",
                  position: "absolute",
                  overflow: "hidden",
                  height: "0px",
                  top: "0px",
                  left: "0px",
                  transform: "matrix(1, 0, 0, 1, 0, 0)",
                  padding: "0px",
                  width: "498px",
                  fontSize: "16px",
                  lineHeight: "22px",
                  boxSizing: "content-box",
                  fontFamily: "Avenir",
                  margin: "0px",
                  fontStyle: "normal",
                  fontVariant: "normal",
                  fontStretch: "100%",
                  fontOpticalSizing: "auto",
                  fontKerning: "auto",
                  fontFeatureSettings: "normal",
                  fontVariationSettings: "normal",
                  letterSpacing: "normal",
                  color: "rgb(12, 19, 31)",
                  border: "0px none rgb(12, 19, 31)",
                  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                  display: "block",
                  minWidth: "0px",
                  animationName: "mui-auto-fill-cancel",
                  animationDuration: "0.01s",
                  resize: "none",
                  fontWeight: 500,
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(12, 19, 31)",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              ></textarea>
              <fieldset
                aria-hidden="true"
                style={{
                  boxSizing: "border-box",
                  padding: "0px 8px",
                  textAlign: "left",
                  position: "absolute",
                  inset: "-5px 0px 0px",
                  margin: "0px",
                  pointerEvents: "none",
                  borderRadius: "8px",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  overflow: "hidden",
                  minWidth: "0%",
                  borderColor: "rgb(132, 139, 155)",
                  border: "1px solid rgb(132, 139, 155)",
                  listStyle: "outside none none",
                  textDecoration: "none solid rgb(12, 19, 31)",
                  fontFamily: "Avenir",
                  transition: "all 0.3s ease-in-out 0s",
                }}
              >
                <legend
                  style={{
                    boxSizing: "border-box",
                    color: "rgb(12, 19, 31)",
                    display: "table",
                    maxWidth: "100%",
                    padding: "0px",
                    whiteSpace: "normal",
                    float: "none",
                    width: "auto",
                    overflow: "hidden",
                    lineHeight: "11px",
                    transition: "width 0.15s cubic-bezier(0, 0, 0.2, 1) 0s",
                    margin: "0px",
                    listStyle: "outside none none",
                    textDecoration: "none solid rgb(12, 19, 31)",
                    fontFamily: "Avenir",
                  }}
                >
                  <span
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      padding: "0px",
                      listStyle: "outside none none",
                      textDecoration: "none solid rgb(12, 19, 31)",
                      fontFamily: "Avenir",
                      transition: "all 0.3s ease-in-out 0s",
                    }}
                  >
                    ​
                  </span>
                </legend>
              </fieldset>
            </div>
          </div>
        </section>
      </SheetContent>
    </Sheet>
  );
};
